import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TemplatesService } from 'src/app/services/templates.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-templates-make',
  templateUrl: './templates-make.page.html',
  styleUrls: ['./templates-make.page.scss'],
})
export class TemplatesMakePage implements OnInit {

  createTemplateForm: FormGroup;




  constructor(
    private fb: FormBuilder,
    private templateService: TemplatesService,
    private router: Router,
    public authService: AuthenticationService,
  ) {
  }

  ngOnInit() {
    this.authService.login();
    this.createTemplateForm = this.fb.group({
      title: [''],
      body: [''],
      timestamp: [''],
    });
  }

  ionViewWillEnter() {
    if (this.authService.isLoggedIn === false) {
      this.router.navigateByUrl('/admin/login');
    }
  }

  formSubmit() {
    if (!this.createTemplateForm.valid) {
      console.log('not valid');
      return false;
    } else {
      this.templateService
        .createTemplate(this.createTemplateForm.value)
        .then((res) => {
          console.log(res);
          this.createTemplateForm.reset();
          this.router.navigateByUrl('/admin/templates');
        })
        .catch((error) => console.log(error));
    }
  }

}
